export const buildPlaceOrderPayload = ({
  form,
  storeItems,
  finalSellerId,
  excludeDelivery,
}) => {
  const payload = {
    full_name: form.full_name,
    phone: form.phone,
    email: form.email,
    country: form.country,
    currency: form.currency,
    seller_id: parseInt(finalSellerId, 10),
    items: storeItems.map((item) => ({
      card_listing_id: item.card_listing.id,
      quantity: item.quantity,
    })),
  };

  if (excludeDelivery) {
    payload.is_exclude = true;
  } else {
    payload.billing_address_line1 = form.billing_address_line1;
    payload.billing_address_line2 = form.billing_address_line2;
    payload.city = form.city;
    payload.state = form.state;
    payload.postal_code = form.postal_code;
  }

  return payload;
};
